import React, { createContext, useContext, useReducer } from 'react';


//Prepares the data layer
export const StateContext = createContext();


//Wrap our app and provide the data layer to every component in the app
export const StateProvider = ({ reducer, initialState, children }) => (
    <StateContext.Provider value={useReducer(reducer, initialState)}>
        {children}
    </StateContext.Provider>
);


//Pull the information from the data layer
export const useStateValue = () => useContext(StateContext);